import { createAsyncThunk } from '@reduxjs/toolkit';
import { clearRealtimeSubscription } from '../slice.js';

// Unsubscribe from real-time updates
export const unsubscribeFromUserProfile = createAsyncThunk(
  'profile/unsubscribeFromUserProfile',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      const { realtimeSubscription } = getState().profile;

      if (realtimeSubscription?.unsubscribe) {
        realtimeSubscription.unsubscribe();
        dispatch(clearRealtimeSubscription());
        return { success: true };
      }

      return { success: false, message: 'No active subscription found' };
    } catch (error) {
      console.error('profileSlice: Error during unsubscribe:', error);
      return rejectWithValue(error.message);
    }
  }
);
